export default {
  dev_null: '/site/api/dev-null',
  migrate: '/etep-migration/api/migrate-etep',
  reset_migrate: '/etep-migration/api/reset-migrate-etep',
  list_migrate: '/etep-migration/api/list-migrations',
};
